import React, { useState } from "react";
import OverlapingCoins from "../../assets/images/icons/overlaping-coins.svg";
import { Label } from "reactstrap";
import { FiArrowLeft, FiEdit, FiInfo } from "react-icons/fi";
import { Link } from "react-router-dom";
import EyeIcon from "../../assets/images/Eye.svg";
import EyeSlashIcon from "../../assets/images/eyeslash.svg";
import { connect } from "react-redux";
import CircularLoader from "../../assets/images/icons/circular-spinner.svg";
import DropDown from "../../assets/images/icons/drop-down.svg";
import { store } from "react-notifications-component";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";

const EntityAuthCard = (props) => {
  const {
    setEntityType,
    dispatch,
    organisationList,
    isFetchingServices,
    selectedOrganization,
    setSelectedOrganization,
  } = props;
  // To check if users are coming from intiation page and use this to handle the stage
  const cameBack = sessionStorage.getItem("cameBack");
  // Others
  const defaultOrganizationImage = require("../../assets/images/icons/organization-icon.svg");
  const [showPassword, setShowPassword] = useState(false);
  const [stage, setStage] = useState(cameBack && cameBack === "true" ? 2 : 1);
  const [formInput, setFormInput] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleBack = () => {
    setEntityType(null);
    setSelectedOrganization(null);
    sessionStorage.removeItem("cameBack");
    sessionStorage.removeItem("entityType");
    sessionStorage.removeItem("selectedOrganization");
  };

  const handleProceed = async () => {
    if (stage === 1) {
      if (!selectedOrganization) {
        store.addNotification({
          title: "Error",
          message: "Select an organization to proceed",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });
      } else {
        setStage(2);
      }
    } else {
      setIsLoading(true);
      dispatch(alertActions.startRequest());
      let payload = {
        userName: formInput.email,
        password: formInput.password,
      };
      commonService
        .login(payload)
        .then(
          (response) => {
            dispatch(alertActions.stopRequest());
            if (response.status === appConstants.SUCCESS_RESPONSE) {
              let user = response.response;
              dispatch(success(user));
              dispatch(commonActions.saveUserData(user));
              moveToInvoicePage();
            } else {
              store.addNotification({
                message: response.response,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 5000,
                },
              });
            }
          },
          (error) => {
            let errorMessage = error.response.data
              ? error.response.data
              : "Unable to handle request";
            store.addNotification({
              title: "Error",
              message: errorMessage,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 5000,
              },
            });
          }
        )
        .finally(() => {
          setIsLoading(false);
        });
      function success(user) {
        return { type: appConstants.SIGN_IN_SUCCESS, user };
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const moveToInvoicePage = () => {
    sessionStorage.setItem("entityType", "organization");
    sessionStorage.setItem(
      "selectedOrganization",
      JSON.stringify(selectedOrganization)
    );
    window.location.href = "/invoice-initation";
  };

  const handleSelectOrganization = (e) => {
    const { _, value } = e.target;
    const selectedOption = organisationList?.find(
      (option) => option.id === parseInt(value)
    );
    setSelectedOrganization(selectedOption);
  };

  return (
    <div className="invoice-creation-content">
      <div className="overlaping-coins">
        <img src={OverlapingCoins} alt="coins" />
      </div>
      <button onClick={handleBack} className="go-back-button">
        <FiArrowLeft className="icon" /> <span>Go Back</span>
      </button>
      <p className="invoice-text title">
        {stage === 1
          ? `Select your organization`
          : `Sign in with your business email`}
      </p>
      <div
        className={`entity-auth-form ${
          stage === 1 ? "add-bottom-padding" : ""
        }`}
      >
        {stage === 1 ? (
          <>
            <Label className="entity-auth-label">Select organization</Label>
            <div className="input-container">
              <select
                className="no-spinner-input entity-auth-label-dropdown"
                type="select"
                name="id"
                value={selectedOrganization?.id}
                onChange={handleSelectOrganization}
              >
                <option value="" disabled hidden selected>
                  Choose an option
                </option>
                {organisationList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.customerName}
                  </option>
                ))}
              </select>
              <img
                src={isFetchingServices ? CircularLoader : DropDown}
                alt="dropdown"
                className={`activity-icon ${
                  isFetchingServices ? "loading" : ""
                }`}
              />
            </div>
          </>
        ) : (
          <>
            <div className="entity-info-card">
              <div className="entity-info">
                <img
                  src={selectedOrganization?.logo || defaultOrganizationImage}
                  alt="organization logo"
                  className="entity-logo"
                />
                <p className="entity-name">
                  {selectedOrganization.customerName}
                </p>
              </div>
              <FiEdit
                className="edit-detail"
                onClick={() => {
                  setStage(1);
                  setFormInput({
                    email: "",
                    password: "",
                  });
                }}
              />
            </div>
            <div>
              <Label className="entity-auth-label">Business email</Label>
              <input
                className="no-spinner-input entity-auth-label-dropdown"
                type="text"
                name="email"
                value={formInput?.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <Label className="entity-auth-label">Password</Label>
              <div style={{ position: "relative" }}>
                <input
                  className="no-spinner-input entity-auth-label-dropdown"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formInput?.password}
                  onChange={handleChange}
                />
                <img
                  src={showPassword ? EyeSlashIcon : EyeIcon}
                  style={{ cursor: "pointer" }}
                  alt="Toggle Password Visibility"
                  width="15"
                  height="15"
                  onClick={togglePasswordVisibility}
                  className="custom-icon"
                />
              </div>
            </div>
          </>
        )}
        <button
          className="entity-auth-button"
          disabled={
            isLoading ||
            (stage === 1 && !selectedOrganization) ||
            (stage === 2 && (!formInput?.email || !formInput?.password))
          }
          onClick={handleProceed}
        >
          {isLoading ? "Processing..." : stage === 1 ? "Continue" : "Sign in"}
        </button>
      </div>
      <p className="entity-auth-help">
        <FiInfo />{" "}
        <span>
          Can’t find your organization? Please contact{" "}
          <Link to="mailto:ncaa@support.gov.ng">ncaa@support.gov.ng</Link>
        </span>
      </p>
    </div>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(EntityAuthCard);
